import { FunctionComponent } from 'react'
import DashboardLayout from '../../components/layout/layout'
import ManageOrderStatusIcon from '../../assets/img/Manage Order Status.png'
import OnlineOrderEntryIcon from '../../assets/img/Online Order Entry.png'
import { Box, Grid, Paper, Typography } from '@mui/material'
import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
//import RecentOrderHistory from '../../components/common/recent-order-history'
import StorageService from '../../services/storageService'

const ActionCard = styled(Paper)(({ theme }) => ({
  width: 180,
  height: 100,
  backgroundColor: '#f2f2f2',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '2px 2px 4px rgba(0,0,0,0.2)',
  borderRadius: 4,
  cursor: 'pointer',
  textAlign: 'center'
}));

const OrderManagementSystem: FunctionComponent = () => {
  const navigate = useNavigate();
  const userInfo = StorageService.getUserInfo();
  const detailedPermissions = useSelector((state: RootState) => state.permission.detailedPermissions) as any;

  const buttons = [
    ...(detailedPermissions?.oms?.checkOrderStatus ? [{ label: 'Check Order Status', disabled: false, icon: <img src={ManageOrderStatusIcon} alt="Check Order Status" style={{ width: 40, height: 40 }} />, navigateTo: '/order-management-system/check-order-status' }] : []),
    ...(detailedPermissions?.oms?.onlineOrderEntry ? [{ label: 'Online Order Entry', disabled: false, icon: <img src={OnlineOrderEntryIcon} alt="Online Order Entry" style={{ width: 40, height: 40 }} />, navigateTo: '/order-management-system/online-order-entry' }] : []),
  ];

  return (
    <DashboardLayout title={"Orders Management"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={""} breadcrumbs={'Orders Management'} activeMenu={'oms'}>
      <Box sx={{ width: '100%', maxWidth: '100%' }}>
        <Grid container spacing={5}
          sx={{
            display: 'flex',
            justifyContent: 'normal',
            alignItems: 'center',
            maxWidth: '100%',
          }}
        >
          {buttons.map((btn, index) => {
            if (!btn.disabled) {
              return (
                <Grid key={index} onClick={() => navigate(btn.navigateTo)}>
                  <ActionCard sx={{ border: '1px solid #e1e1e1', boxShadow: ` inset 0 0 10px rgba(0, 0, 0, 0.1), inset 0 0 5px rgba(255, 255, 255, 0.6)` }}>
                    <Box position="relative">
                      {btn.icon}
                    </Box>
                    <Typography variant="body2" fontWeight="bold" sx={{ width: '65%' }}>
                      {btn.label}
                    </Typography>
                  </ActionCard>
                </Grid>
              );
            }
            return null;
          })}
        </Grid>
        
        {/* <RecentOrderHistory /> */}
      </Box>
    </DashboardLayout>
  )
}

export default OrderManagementSystem